import { Surreal } from "surrealdb";
import { surrealdbWasmEngines } from "@surrealdb/wasm";
const db = new Surreal({
    engines: surrealdbWasmEngines(),
});

async function fetchSQLFromPreTag() {
  try {
    // Fetch the HTML content from /site.sql
    const response = await fetch('/site.sql');
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Parse the response as text
    const htmlText = await response.text();

    // Create a new DOM parser
    const parser = new DOMParser();

    // Parse the HTML text into a Document object
    const doc = parser.parseFromString(htmlText, 'text/html');

    // Find the first <pre> tag in the document
    const preTag = doc.querySelector('pre');

    // Check if a <pre> tag was found and extract its text content
    if (preTag) {
      const sqlContent = preTag.textContent;
      return sqlContent;
    } else {
      throw new Error('No <pre> tag found in the HTML.');
    }
  } catch (error) {
    console.error('Error fetching or parsing the SQL file:', error);
  }
}

// Call the function to execute the fetch and extraction
let sql = await fetchSQLFromPreTag();
const start = performance.now();

await db.connect("mem://");
await db.use({ namespace: "test", database: "test" });
await db.query(sql);

window.db = db;
// Code block to measure
const end = performance.now();
const myEvent = new CustomEvent('DatabaseReady', {
  detail: { took: end-start, db },
  bubbles: true,
  cancelable: true
});
window.dispatchEvent(myEvent);
